import type { FlowFacts, FlowState } from './types.js';

/** Porters carry batches of up to four bags rack→loading pad over the authored walk; proximity pickup is a named residual. */
export function advanceFlowPorters(state: FlowState, facts: FlowFacts): void {
    for (const porter of state.porters) {
        porter.remainingFrames = Math.max(0, porter.remainingFrames - 60);
        if (porter.remainingFrames > 0) continue;
        if (porter.phase === 'loading') {
            state.deliveredBagMilli += porter.carriedMilli; porter.carriedMilli = 0;
            porter.phase = 'returning'; porter.remainingFrames = facts.porterOneWayFrames;
        } else {
            porter.phase = 'rack';
            const carried = Math.min(4000, state.freeBagMilli);
            if (!carried) continue;
            state.freeBagMilli -= carried; porter.carriedMilli = carried;
            porter.phase = 'loading'; porter.remainingFrames = facts.porterOneWayFrames;
        }
    }
}
